export function originUpdatedAt(...records) {
  return records.reduce((latest, record) => {
    const stamp = Number(record?.updatedAt || 0);
    return Number.isFinite(stamp) && stamp > latest ? stamp : latest;
  }, 0);
}

export function plannerUserEditedAfterOrigin(item = {}, originStamp = 0) {
  const editedAt = Number(item.userEditedAt || 0);
  return Number.isFinite(editedAt) && editedAt > Number(originStamp || 0);
}

export function applyProtectedPlannerFields(item = {}, patch = {}, originStamp = 0) {
  const preserveManualFields = plannerUserEditedAfterOrigin(item, originStamp);
  const next = { ...item };
  Object.entries(patch).forEach(([field, value]) => {
    if (preserveManualFields && ["title", "date", "subject"].includes(field)) return;
    next[field] = value;
  });
  next.lastSyncFromOrigin = Number(originStamp || 0);
  return next;
}
